import styled, { css } from 'styled-components'
import { Devices, Spacings } from '@styles'
import { BaseWrapper, UploadButton, Button } from '@base'

export const AdminWrapper = styled.div`
	display: flex;
	flex-direction: column;
	flex-grow: 1;
`
export const InitialAdminHeaderWrapper = styled(BaseWrapper)`
	margin-bottom: ${Spacings.SPACING_4B};
`
const FormSection = styled.div`
	padding: ${Spacings.SPACING_4B} 0 ${Spacings.SPACING_4B};
	border-bottom: 1px solid ${({ theme }) => theme.palette.background.searchgrey};
	display: block;
	@media ${Devices.mobile} {
		display: flex;
	}
`
export const InitialAdminFormWrapper = styled(FormSection)`
	padding: ${Spacings.SPACING_2B} 0 ${Spacings.SPACING_2B};
	&:last-of-type {
		margin-bottom: 0;
	}
`

export const SectionItemWrapper = styled.div`
	flex-shrink: unset;
	// flex-basis: 100%;
	// height: 100%;
	margin-top: ${Spacings.SPACING_2B};
	display: ${({ isFlex }) => (isFlex ? 'flex' : 'block')};
	${({ isLeftMargin }) => {
		if (isLeftMargin) {
			return css`
				& > div {
					&:nth-child(2) {
						margin-left: 0px;
					}
					&:nth-child(3) {
						margin-left: 0px;
					}
					&:nth-child(4) {
						margin-left: 0px;
					}
				}
				display: block;
				@media ${Devices.mobile} {
					display: flex;
					& > div {
						&:nth-child(2) {
							margin-left: 10px;
						}
						&:nth-child(3) {
							margin-left: 10px;
						}
						&:nth-child(4) {
							margin-left: 10px;
						}
					}
				}
			`
		}
	}}
`
export const InputWapper = styled.div`
	width: auto;
	flex: auto;

	@media ${Devices.laptop} {
		width: 100%;
		flex: 1;
	}
`

export const UploadButtonFiled = styled(UploadButton)`
	height: ${Spacings.SPACING_3B};
	width: 100%;
	margin: 0;
	@media ${Devices.mobile} {
		width: 12rem;
		margin: ${Spacings.SPACING_5B} ${Spacings.SPACING_4B} 0 ${Spacings.SPACING_2B};
	}
`

export const CreateToolsWrapper = styled(BaseWrapper)`
	flex-grow: 1;
	display: flex;
	flex-direction: column;
`

export const PsuedoWrapper = styled.div`
	position: sticky;
	bottom: 0;
	z-index: 1;
	background: ${({ theme }) => theme.palette.background.searchgrey};
	border-top: 1px solid ${({ theme }) => theme.palette.background.searchgrey};

	@media ${Devices.tablet} {
		margin: 0 -${Spacings.SPACING_4B};
	}
`
export const CreateEnquiryFooter = styled.div`
	padding: ${Spacings.SPACING_3B} ${Spacings.SPACING_4B};
	background: ${({ theme }) => theme.palette.background.white};
	box-shadow: 0 ${Spacings.SPACING_1B} ${Spacings.SPACING_5B} 0 rgb(0 0 0 / 5%);
	display: flex;
	flex-direction: column;
`
export const ButtonsWrapper = styled.div`
	display: flex;
	margin-top: ${Spacings.SPACING_3B};
`
export const BaseButton = styled(Button)``

export const RightPositionedButton = styled(BaseButton)`
	margin-left: ${({ noLeftAuto }) => (noLeftAuto ? 0 : 'auto')};
	@media ${Devices.tablet} {
		margin-left: ${({ leftAuto }) => (leftAuto ? 'auto' : Spacings.SPACING_4B)}};
	}
`
export const EndStepButton = styled(RightPositionedButton)``

export const CalendarWapper = styled.div`
	margin-left: 0px;
	@media ${Devices.mobile} {
		margin-left: 10px;
	}
`
export const StepWrapper = styled(BaseWrapper)`
	flex-grow: 1;
	padding: ${Spacings.SPACING_3B} ${Spacings.SPACING_4B};
	${({ isFlex }) => {
		if (isFlex) {
			return css`
				display: flex;
				flex-direction: column;
			`
		}
	}}
`
export const StepTopWrapper = styled(StepWrapper)`
	padding: 0;
	flex-grow: 0;
	margin-bottom: ${Spacings.SPACING_4B};
	display: flex;

	button {
		min-width: fit-content;
	}
`

export const BannerText = styled.div`
	display: flex;
	align-items: center;
	flex-grow: 1;
`